// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS FileThumbnail INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import getFileIconByContentType from "./utils/getFileIconByContentType";

/**
 * @visibleName FileThumbnail DEPRECATED
*/

var FileThumbnail = function FileThumbnail(props) {
  var id = props.id,
    className = props.className,
    color = props.color,
    contentType = props.contentType,
    onThumbnailClick = props.onThumbnailClick,
    size = props.size,
    style = props.style;
  var icon = getFileIconByContentType(contentType);
  return /*#__PURE__*/React.createElement("div", {
    className: "ui-file-thumbnail ".concat(className)
  }, onThumbnailClick ? /*#__PURE__*/React.createElement("a", {
    id: id,
    onClick: onThumbnailClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    color: color,
    icon: icon,
    size: size,
    style: style
  })) : /*#__PURE__*/React.createElement(Icon, {
    color: color,
    icon: icon,
    size: size,
    style: style
  }));
};
FileThumbnail.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Color of icon */
  color: PropTypes.string,
  /** Type of file (i.e.: `'image/png'`) */
  contentType: PropTypes.string.isRequired,
  /** clickable functionality. */
  onThumbnailClick: PropTypes.func,
  /** Size of FileThumbnail Icon */
  size: PropTypes.number,
  /** Override the inline-styles of the FileThumbnail Icon || **Not Recommended** */
  style: PropTypes.object
};
FileThumbnail.defaultProps = {
  id: '',
  className: '',
  color: '',
  contentType: '',
  onThumbnailClick: null,
  size: 60,
  style: {}
};
export default FileThumbnail;